import { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyTitle } from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';

const SearchFeedback = ({ icon, title, text, actions, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('p-4 text-center', className);

	// Render
	return (
		<Empty className={rootClassName}>
			<EmptyContent>
				{icon && (
					<EmptyMedia>
						<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
					</EmptyMedia>
				)}
				{title && <EmptyTitle>{title}</EmptyTitle>}
				{text && <EmptyDescription>{text}</EmptyDescription>}
				{actions && <EmptyActions className='flex-middle'>{actions}</EmptyActions>}
			</EmptyContent>
		</Empty>
	);
};
export { SearchFeedback };
